import axios from 'axios';
import api from '../../config/config.json';
import { env } from '../../config/env';
import { logout, selectToken, updToken } from 'features/auth';
import Cookies from 'universal-cookie';
import { setVisible, setVisibleSecondary } from 'features/modal';
import { resetMenu } from 'features/menu';
import { setDataToast, setVisibleToast } from 'features/toast';
const CONFIG = api[env];

export const getData = async (
    attributes: object,
    getState: Function,
    dispatch: Function,
): Promise<any> => {
    let result: any;
    let token: any = selectToken(getState())
    const jsonHdr = token && {
        Authorization: 'Bearer ' + token,
    };
    try {
        await axios
            .post(CONFIG.url_api + CONFIG.path_api, attributes, {
                timeout: 300000,
                headers: {
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache',
                    Expires: '0',
                    ...jsonHdr
                },
            })
            .then((res: any) => {
                const cookies = new Cookies();
                const refreshToken = cookies.get('refreshToken');
                if (refreshToken) {
                    dispatch(updToken(refreshToken));
                    cookies.remove('refreshToken');
                }
                result = res.data;
                if (!result.result && result.message === 'SIN AUTORIZACION'){
                    dispatch(logout());
                    dispatch(setVisibleSecondary(false));
                    dispatch(setVisible(false));
                    dispatch(resetMenu());
                    const alert = { title: 'ACCIÓN INCOMPLETA', message: "NO TIENE AUTORIZACIÓN PARA REALIZAR ESTA ACCIÓN", data: null, type: 'Crimson', time: Date.now() };
                    dispatch(setDataToast(alert));
                    dispatch(setVisibleToast(true));
                    dispatch(setVisible(false));
                    setTimeout(() => {
                        dispatch(setVisibleToast(false));
                    }, 4000);
                }
            })
            .catch((e: any) => {
                dispatch(logout());
                dispatch(setVisibleSecondary(false));
                dispatch(setVisible(false));
                dispatch(resetMenu());
                result = { result: false, message: e.message, data: null };
            });

    } catch (e: any) {
        result = { result: false, message: e.message, data: null };
    }
    return result;
};

export const login = async (
    attributes: object,
    getState: Function,
    dispatch: Function,
): Promise<any> => {
    let result: any;
    try {
        await axios
            .post(CONFIG.url_api + CONFIG.path_login, attributes, {
                timeout: 300000,
                headers: {
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache',
                    Expires: '0',
                },
            })
            .then((res: any) => {
                const cookies = new Cookies();
                const refreshToken = cookies.get('refreshToken');
                if (refreshToken) {
                    dispatch(updToken(refreshToken));
                    cookies.remove('refreshToken');
                }
                result = res.data;

            })
            .catch((e: any) => {
                dispatch(logout());
                dispatch(setVisibleSecondary(false));
                dispatch(setVisible(false));
                dispatch(resetMenu());
                result = { result: false, message: e.message, data: null };
            });

    } catch (e: any) {
        result = { result: false, message: e.message, data: null };
    }
    return result;
};

export const getFile = async (attributes: object): Promise<any> => {
    let result: any;

    try {
        let response: any = await axios.post(CONFIG.url_api + CONFIG.path_api_file_download, attributes, {
            responseType: 'blob',
            timeout: 300000,
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: '0',
            },
        });
        
        return { blob: response.data };
    } catch (e: any) {
        result = null;
    }
    return result;
};


export const postFile = async (
    attributes: object,
    getState: Function,
    dispatch: Function,
): Promise<any> => {
    let result: any;
    let token: any = selectToken(getState())
    const jsonHdr = token && {
        Authorization: 'Bearer ' + token,
    };

    try {
        await axios
            .post(CONFIG.url_api + CONFIG.path_api_file, attributes, {
                timeout: 300000,
                headers: {
                    'content-type': 'multipart/form-data',
                    ...jsonHdr
                },

            })
            .then((res: any) => {
                const cookies = new Cookies();
                const refreshToken = cookies.get('refreshToken');
                if (refreshToken) {
                    dispatch(updToken(refreshToken));
                    cookies.remove('refreshToken');
                }
                result = res.data;

            })
            .catch((e: any) => {
                dispatch(logout());
                dispatch(setVisibleSecondary(false));
                dispatch(setVisible(false));
                dispatch(resetMenu());
                result = { result: false, message: e.message, data: null };
            });
    } catch (e: any) {
        result = { result: false, message: e.message, dataFile: null };
    }
    return result;
};

export const deleteFile = async (
    attributes: object,
    getState: Function,
    dispatch: Function,
): Promise<any> => {
    let result: any;
    let token: any = selectToken(getState())
    const jsonHdr = token && {
        Authorization: 'Bearer ' + token,
    };

    try {
        await axios
            .post(CONFIG.url_api + CONFIG.path_api_file_delete, attributes, {
                timeout: 300000,
                headers: {
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache',
                    Expires: '0',
                    ...jsonHdr
                },
            })
            .then((res: any) => {
                const cookies = new Cookies();
                const refreshToken = cookies.get('refreshToken');
                if (refreshToken) {
                    dispatch(updToken(refreshToken));
                    cookies.remove('refreshToken');
                }
                result = res.data;

            })
            .catch((e: any) => {
                dispatch(logout());
                dispatch(setVisibleSecondary(false));
                dispatch(setVisible(false));
                dispatch(resetMenu());
                result = { result: false, message: e.message, data: null };
            });
    } catch (e: any) {
        result = { result: false, message: e.message, data: null };
    }
    return result;
};